import { render, staticRenderFns } from "./activityLog.vue?vue&type=template&id=b106493a"
import script from "./activityLog.vue?vue&type=script&lang=js"
export * from "./activityLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports